/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/site-menu.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/site-menu.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
  (function () {
    var s = document.querySelector('[data-gl-scrim]');
    if (s && s.parentElement !== document.body) document.body.appendChild(s);

    /* Flagship hover video. The <video> is preload:none, so it is 0 bytes until
       play() is called here on hover; .is-ready fades it in only once it can paint,
       so there is no black-frame flash. Pause + rewind on leave. */
    document.querySelectorAll('.gl-mega .gl-flag').forEach(function (card) {
      var v = card.querySelector('.gl-flag__video');
      if (!v) return;
      card.addEventListener('mouseenter', function () {
        var p = v.play();
        if (p && p.then) { p.then(function () { v.classList.add('is-ready'); }).catch(function () {}); }
        else { v.classList.add('is-ready'); }
      });
      card.addEventListener('mouseleave', function () {
        v.pause();
        v.classList.remove('is-ready');
        try { v.currentTime = 0; } catch (e) {}
      });
    });
  })();

  /* 2026-07-30 - Joel: "the buttons on this menu jump when you press them.
     i would rather have a spinning wheel". Pressing a header menu link shows
     a spinning ring on the pressed button until the next page takes over.
     Styles are the MENU PRESS SPINNER block in gl-nav.css. Never blocks or
     redirects the click, so nothing else in the menu can break. Delete this
     block and that CSS block to roll back.

     2026-08-11 - DESKTOP ONLY from here. Joel, on the phone drawer: "do not
     show a smaller spinning wheel anywhere else in this menu". The selector
     below dropped #header-mobile__menu; that drawer dims the whole screen and
     spins one big ring instead.

     2026-08-11, later - Joel: "make this a rule for desktop and mobile too".
     So the desktop header now does the same thing the drawer does: one 64px
     ring centered on the viewport over a darkened but see-through scrim, from
     snippets/aoam-load-overlay.liquid. No wheel is grown inside the pressed
     link any more. The MENU PRESS SPINNER CSS in gl-nav.css is left in place,
     dormant, as the rollback path. */
  (function () {
    function clearSpinners() {
      document.querySelectorAll('.gl-nav-spinner').forEach(function (s) { s.remove(); });
      document.querySelectorAll('.gl-nav-loading').forEach(function (a) { a.classList.remove('gl-nav-loading'); });
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!e.target || !e.target.closest) return;
      var a = e.target.closest('#header-navigation a[href]');
      if (!a || a.target === '_blank') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      clearSpinners();
      if (!window.AOAM_LOAD) return;
      window.AOAM_LOAD.show();
      /* A handler registered later can still cancel this navigation. A timeout of 0 runs once
         the event has finished dispatching, which is the first moment defaultPrevented is
         trustworthy, so a cancelled click lifts the scrim instead of dimming the page for 8s. */
      setTimeout(function () { if (e.defaultPrevented) window.AOAM_LOAD.hide(); }, 0);
    });
    /* 2026-09-16 (Claude) - filmstrip posters load at 600w like the old tiles, so page weight is
       unchanged. The first time a visitor opens a panel, hand its posters a sharper srcset: an open
       poster is about 820px of cover-cropped art. Delete this block to roll back. */
    document.querySelectorAll('#header-navigation li.gl-has-mega').forEach(function (li) {
      function promote() {
        li.removeEventListener('mouseenter', promote);
        li.removeEventListener('focusin', promote);
        li.querySelectorAll('img[data-film-srcset]').forEach(function (img) {
          img.sizes = img.getAttribute('data-film-sizes') || '820px';
          img.srcset = img.getAttribute('data-film-srcset');
          img.removeAttribute('data-film-srcset');
        });
      }
      li.addEventListener('mouseenter', promote);
      li.addEventListener('focusin', promote);
    });
    /* 2026-10-01 (Claude) - Joel picked mockup E: an iPad held sideways (1081px+) gets this desktop menu,
       whose panels open on hover or :focus-within. A touch screen cannot hover, so a tap went straight to the
       top-level page and the panels were unreachable. On no-hover screens only, the first tap focuses the link
       (which opens the panel through :focus-within) and a second tap on the same word follows it. Tapping
       elsewhere blurs it and closes the panel. Mouse and trackpad are untouched. Delete this block to roll back. */
    if (!window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('#header-navigation li.gl-has-mega > a').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (window.innerWidth < 1081) return;
          var li = a.parentElement;
          if (li.contains(document.activeElement) && li.dataset.glTap === '1') return;
          e.preventDefault();
          document.querySelectorAll('#header-navigation li.gl-has-mega').forEach(function (o) { o.dataset.glTap = ''; });
          li.dataset.glTap = '1';
          a.focus({ preventScroll: true });
        });
      });
    }
    /* A bfcache Back restores the old page exactly as it was left. */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) clearSpinners(); });
  })();
  /* 2026-09-23 (Claude) - MENU INSTRUMENTATION. Nothing measured the menus: GA4 carried no
     menu_* event at all, so "how is the new menu performing" could only ever be answered by
     proxy metrics. Fires menu_open (first open of a desktop mega panel, or of the mobile
     drawer / a drawer category) and menu_click (any link followed out of either menu), reusing
     the already-registered event_category / event_label custom dimensions so nothing needs
     registering in GA4 first. Same deferred-gtag queue as kit-builder.js, because this script
     runs well before gtag exists. Passive: never blocks, cancels or redirects a click.
     Delete this whole block to roll back. */
  (function () {
    var q = [], t = null, start = Date.now();
    function ready(){ try { var g = window.google_tag_manager; if (!g) return false;
      for (var k in g) if (k.indexOf('G-') === 0) return true; } catch(_){} return false; }
    function flush(force){ try {
      if (!force && !ready() && Date.now() - start < 20000) return;
      if (t){ clearInterval(t); t = null; }
      while (q.length){ var e = q.shift();
        try { if (typeof window.gtag === 'function') window.gtag('event', e.n, e.p); } catch(_){}
      } } catch(_){} }
    function ga(n, p){ try {
      q.push({ n: n, p: p || {} });
      if (ready() || Date.now() - start >= 20000){ flush(true); return; }
      if (!t) t = setInterval(flush, 250);
    } catch(_){} }
    window.addEventListener('pagehide', function () { flush(true); }, true);

    function txt(el){ return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
    /* 2026-09-24 (Claude) - the first day of menu_click data came back with labels like
       "Light Saber KitsSol, Stellar, Honeycomb and Butterfly.Shop n", because a mega-panel tile
       anchor wraps its title, its blurb AND its CTA, and textContent concatenates all three with
       no separator. Prefer the tile's own title element: .gl-film__lbl on desktop, .gl-cat__lbl
       and .gl-ex__lbl in the mobile drawer. Falls back to the old behaviour when there is none,
       so a plain text link is unchanged. */
    function lbl(el){
      if (!el) return '';
      try {
        var t = el.querySelector('.gl-split__lbl, .gl-film__lbl, .gl-cat__lbl, .gl-ex__lbl, h1, h2, h3, h4, h5, h6');
        if (t) { var s = txt(t); if (s) return s; }
      } catch (e) {}
      return txt(el);
    }
    var seen = {};
    function opened(surface, panel){
      var k = surface + '|' + panel;
      if (seen[k]) return;
      seen[k] = 1;
      ga('menu_open', { event_category: 'menu_' + surface, event_label: panel });
    }

    document.querySelectorAll('#header-navigation li.gl-has-mega').forEach(function (li) {
      function fire(){ opened('desktop', txt(li.querySelector('a')) || 'panel'); }
      li.addEventListener('mouseenter', fire);
      li.addEventListener('focusin', fire);
    });

    document.addEventListener('click', function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        var nav = e.target.closest('#header-navigation, #mobile-navigation');
        if (!nav) return;
        var surface = nav.id === 'mobile-navigation' ? 'mobile' : 'desktop';
        var a = e.target.closest('a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#'){ opened(surface, txt(a) || 'drawer'); return; }
        var panel = a.closest('li.gl-has-mega, li.gl-dcat');
        var head = panel ? lbl(panel.querySelector('a')) : '';
        ga('menu_click', {
          event_category: 'menu_' + surface,
          event_label: (head && head !== lbl(a) ? head + ' > ' : '') + (lbl(a) || href),
          link_url: href
        });
      } catch(_){}
    }, true);
  })();
